import BaseStore from "../base/BaseStore";
import PopinaRestaurant from "../model/popina/PopinaRestaurant";

import { ActionInterface, PopinaAtionType } from "../constant/ActionConstant"
import AppDispatcher from "../dispatcher/AppDispatcher";

class PopinaStore extends BaseStore {

    private _restaurant: PopinaRestaurant|undefined

    constructor() {
        super();
        this._restaurant = undefined;
    }

    public get restaurant(): PopinaRestaurant|undefined {
        return this._restaurant;
    }

    setRestaurant(resto: any) {
        this._restaurant = resto;
        this.emitChange();
    }

}

const storeActions = (store: PopinaStore) => {
    return (action: ActionInterface) => {
        switch(action.type) {

            case PopinaAtionType.SET_POPINA_CARTE:
                store.setRestaurant(action.data);
                break;
        }
    }
}

const PopinaStoreShared = new PopinaStore();
PopinaStoreShared.dispatchToken = AppDispatcher.register(storeActions(PopinaStoreShared) as (payload: unknown) => void);

export default PopinaStoreShared;
export const store = PopinaStore;
export const action = storeActions;